import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MoreIcon from '@material-ui/icons/MoreVert';
import { Link } from 'react-router-dom';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import { withStyles } from '@material-ui/core/styles';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import PermIdentity from '@material-ui/icons/PermIdentity';
import logo from '../../resources/logo.png';
import ButtonLink from './ButtonLink';
import { authService } from '../apis/AuthService';

import '../../css/components/navbar.css';

const theme = createMuiTheme({
  palette: {
    primary: { main: 'rgba(255,255,255,0.75)' }
  }
});

const styles = theme => ({
  root: {
    width: '100%'
  },
  logoLetter: { fontSize: '20px' },
  grow: {
    flexGrow: 1
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block'
    }
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex'
    }
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  },
  appBar: {
    backgroundColor: '#404060',
    height: '60px',
    boxShadow: 'none',
    opacity: 1
  },
  logoLink: {
    width: '40px'
  },
  signoutButton: {
    color: 'rgba(255,255,255,0.75)',
    fontSize: '18px'
  },
  text: {
    textTransform: 'none'
  }
});

class HomeNavigationBar extends React.Component {
  state = {
    anchorEl: null,
    mobileMoreAnchorEl: null
  };

  changeStyle = isActive => {
    if (isActive) {
      return {
        fontFamily: 'Roboto',
        fontSize: '18px',
        fontWeight: '500',
        letterSpacing: '0.23px',
        lineHeight: '21px',
        borderBottom: 'solid 3px #FFFFFF',
        display: 'inline'
      };
    } else {
      return {
        color: 'rgba(255,255,255,0.75)',
        fontFamily: 'Roboto',
        fontSize: '18px',
        fontWeight: '500',
        letterSpacing: '0.23px',
        lineHeight: '21px'
      };
    }
  };

  handleProfileMenuOpen = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null });
    this.handleMobileMenuClose();
  };
  handleMobileMenuOpen = event => {
    this.setState({ mobileMoreAnchorEl: event.currentTarget });
  };

  handleMobileMenuClose = () => {
    this.setState({ mobileMoreAnchorEl: null });
  };

  signout = () => {
    authService.signout(() => {
      console.log('Successfuly signed-out.');
    });
  };

  render() {
    const { mobileMoreAnchorEl } = this.state;
    const { classes } = this.props;
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

    const renderMobileMenu = (
      <div>
        <Menu
          anchorEl={mobileMoreAnchorEl}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={isMobileMenuOpen}
          onClose={this.handleMobileMenuClose}
        >
          <MenuItem>
            <ButtonLink
              path={`/channel/${sessionStorage.getItem('channelId')}/groups`}
              className={classes.text}
            >
              <div>Channel Content</div>
            </ButtonLink>
          </MenuItem>

          <MenuItem>
            <ButtonLink
              color="inherit"
              path={'/operators'}
              className={classes.text}
            >
              <div>Operators</div>
            </ButtonLink>
          </MenuItem>

          <MenuItem>
            <ButtonLink
              color="inherit"
              hidden={this.props.isLogin === true}
              path={`/channel/${sessionStorage.getItem('channelId')}/groups`}
              onClick={this.signout}
              className={classes.text}
            >
              <PermIdentity />
              <div>Sign Out</div>
            </ButtonLink>
          </MenuItem>
        </Menu>
      </div>
    );

    return (
      <div id="navbar" className={classes.root}>
        <AppBar position="static" className={classes.appBar}>
          <Toolbar>
            <Link to="/" className={classes.logoLink}>
              <img src={logo} alt="Logo" />
            </Link>
            <Link to="/">
              <div className={classes.logoLetter}>QikServe</div>
            </Link>

            <div className={classes.grow} />
            <div className={classes.sectionDesktop}>
              {!this.props.isLogin && (
                <ButtonLink
                  id="gfc-tab-btn"
                  color="inherit"
                  path={`/channel/${sessionStorage.getItem(
                    'channelId'
                  )}/groups`}
                  className={classes.text}
                >
                  <div style={this.changeStyle(this.props.isGroupHome)}>
                    Channel Content
                  </div>
                </ButtonLink>
              )}

              {!this.props.isLogin && (
                <ButtonLink
                  hidden={this.props.isLogin === true}
                  path={'/'}
                  onClick={this.signout}
                  className={classes.text}
                >
                  <MuiThemeProvider theme={theme}>
                    <PermIdentity color="primary" />
                  </MuiThemeProvider>
                  <div className={classes.signoutButton}> Sign Out</div>
                </ButtonLink>
              )}
            </div>
            {!this.props.isLogin && (
              <div className={classes.sectionMobile}>
                <IconButton
                  aria-haspopup="true"
                  onClick={this.handleMobileMenuOpen}
                  color="inherit"
                >
                  <MoreIcon />
                </IconButton>
              </div>
            )}
          </Toolbar>
        </AppBar>
        {renderMobileMenu}
      </div>
    );
  }
}

export default withStyles(styles)(HomeNavigationBar);
